export enum SIGNUP_STAGE {
  SIGN_UP = "signUp",
}

export enum SIGNUP_TYPE {
  NORMAL = "normal",
  GOOGLE = "google"
}
